import React, { useContext } from "react";
import { DataContext } from '../providers/dataProvider';
import lc from "../cmprtbl.module.scss";

function TableHeader() {
    const ctx = useContext( DataContext );
    const { data: { header: { cols, levels } } } = ctx;

    return (
        <div className={ lc.thead }>
            <div className={ lc.tr }>
                <div className={ lc.th }>{ cols[0].text }</div>
                <div className={ lc.th }>
                    <div className={ lc.tr }>
                        <div className={ lc.th }>
                            { cols[1].text }
                        </div>
                    </div>
                    <div className={ lc.tr }>
                        <div className={ lc.th }>{ levels[0].text }</div>
                        <div className={ lc.th }>{ levels[1].text }</div>
                        <div className={ lc.th }>{ levels[2].text }</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TableHeader;
